import { DateUtil } from "../shared/date_util";

export class Folder {

    private _folder_name: string = "";
    private _name: string = "";
    private _created_timestamp: Date = new Date();
    private _updated_timestamp: Date = new Date();

    public get folder_name(): string {
        return this._folder_name;
    }

    public set folder_name(value: string) {
        this._folder_name = value;
    }

    public get name(): string {
        return this._name;
    }

    public set name(value: string) {
        this._name = value;
    }

    public get created_timestamp(): Date {
        return this._created_timestamp;
    }

    public set created_timestamp(value: any) {
        this._created_timestamp = DateUtil.getDateFromValue(value, false);
    }

    public get updated_timestamp(): Date {
        return this._updated_timestamp;
    }
    public set updated_timestamp(value: any) {
        this._updated_timestamp = DateUtil.getDateFromValue(value, false);
    }

    public static toFolders(obj: string | Object[]): Folder[] {
        let obj2 = obj;

        // If not string, then assumption is an
        // array of objects.
        if (typeof obj === "string") {
            obj2 = JSON.parse(obj);
        }

        let logFolders: Folder[] = [];

        for (const o2 of (<Object[]>obj2)) {
            logFolders.push(Folder.toFolder(o2));
        }

        return logFolders;
    }

    public static toFolder(obj: string | Object): Folder {
        let obj2 = obj;

        if (typeof obj === "string") {
            obj2 = JSON.parse(obj);
        }

        // Convert generic object to type of Folder.
        return Object.assign(new Folder(), obj2);
    }
}
